import { gqlMutate, gqlQuery } from '@hapana/shared/web/services/requests.service'
import { AVAILABLE_EQUIPMENTS_MOCK, EQUIPMENTS_MOCK } from '_mocks/equipments.mock'

import {
  createEquipment as createEquipmentMutation,
  updateEquipment as updateEquipmentMutation,
  getEquipmentImagePresignedUrlMutation,
  generateTanningEquipmentKeyMutation,
  disableEquipment as disableEquipmentMutation,
  enableEquipment as enableEquipmentMutation,
  updateEquipmentStatus as updateEquipmentStatusMutation,
  resyncEquipments as resyncEquipmentsMutation,
  deleteEquipment as deleteEquipmentMutation,
  updateTanningIntegration as updateTanningIntegrationMutation,
  requestMaintenance as requestMaintenanceMutation,
  tanningAgentDownloadUrlMutation,
  resetEquipment as resetEquipmentMutation,
} from './graphql/equipment.mutations'
import {
  availableEquipmentsQuery,
  equipmentQuery,
  equipmentsQuery,
  equipmentActivityQuery,
  equipmentAssignmentsQuery,
  equipmentAssignmentsBySiteQuery,
  tanningEligibilityQuery,
  equipmentSessionTypeAvailabilityQuery,
  equipmentDiagnosticsQuery,
  maintenanceEmailConfiguredQuery,
} from './graphql/equipments.queries'

export const getEquipments = gqlQuery({
  key: 'EQUIPMENTS',
  query: equipmentsQuery,
  mockResponse: {
    equipments: EQUIPMENTS_MOCK,
  },
})

export const getEquipment = gqlQuery({
  key: 'EQUIPMENT',
  query: equipmentQuery,
  mockResponse: {
    equipment: EQUIPMENTS_MOCK.equipments[0],
  },
})

export const getAvailableEquipments = gqlQuery({
  key: 'AVAILABLE_EQUIPMENTS',
  query: availableEquipmentsQuery,
  mockResponse: {
    availableEquipments: AVAILABLE_EQUIPMENTS_MOCK,
  },
})

export const getEquipmentActivity = gqlQuery({
  key: 'EQUIPMENT_ACTIVITY',
  query: equipmentActivityQuery,
})

export const getEquipmentAssignments = gqlQuery({
  key: 'EQUIPMENT_ASSIGNMENTS',
  query: equipmentAssignmentsQuery,
})

export const getEquipmentAssignmentsBySite = gqlQuery({
  key: 'EQUIPMENT_ASSIGNMENTS_BY_SITE',
  query: equipmentAssignmentsBySiteQuery,
})

export const createEquipment = ({
  siteId,
  name,
  timerId,
  minDelayMinutes,
  maxDelayMinutes,
  defaultDelayMinutes,
  defaultTimerMinutes,
  minTimerMinutes,
  maxTimerMinutes,
  category,
  nonUvCategory,
  qualityCategory,
  description,
  manufacturer,
  siteSessionTypeIds,
  copyImageFromEquipmentId,
}) =>
  gqlMutate({
    mutation: createEquipmentMutation,
    variables: {
      siteId,
      input: {
        siteId,
        name,
        timerId,
        minDelayMinutes,
        maxDelayMinutes,
        defaultDelayMinutes,
        defaultTimerMinutes,
        minTimerMinutes,
        maxTimerMinutes,
        category,
        nonUvCategory,
        qualityCategory,
        description,
        manufacturer,
        siteSessionTypeIds: siteSessionTypeIds?.length ? siteSessionTypeIds : undefined,
        copyImageFromEquipmentId,
      },
    },
  })

export const updateEquipment = ({
  _siteId,
  name,
  timerId,
  minDelayMinutes,
  maxDelayMinutes,
  defaultDelayMinutes,
  defaultTimerMinutes,
  minTimerMinutes,
  maxTimerMinutes,
  category,
  nonUvCategory,
  qualityCategory,
  description,
  manufacturer,
  equipmentId,
  siteSessionTypeIds,
}) =>
  gqlMutate({
    mutation: updateEquipmentMutation,
    variables: {
      input: {
        name,
        timerId,
        minDelayMinutes,
        maxDelayMinutes,
        defaultDelayMinutes,
        defaultTimerMinutes,
        minTimerMinutes,
        maxTimerMinutes,
        category,
        nonUvCategory,
        qualityCategory,
        description,
        manufacturer,
        siteSessionTypeIds: siteSessionTypeIds?.length ? siteSessionTypeIds : [],
      },
      equipmentId,
    },
  })

export const getEquipmentImagePresignedUrl = ({ siteId, equipmentId, fileExtension }) =>
  gqlMutate({
    mutation: getEquipmentImagePresignedUrlMutation,
    variables: {
      siteId,
      equipmentId,
      fileExtension,
    },
  })

export const generateTanningEquipmentKey = ({ siteId }) =>
  gqlMutate({
    mutation: generateTanningEquipmentKeyMutation,
    variables: {
      siteId,
    },
  })

export const disableEquipment = ({ equipmentId }) =>
  gqlMutate({
    mutation: disableEquipmentMutation,
    variables: { equipmentId },
  })

export const enableEquipment = ({ equipmentId }) =>
  gqlMutate({
    mutation: enableEquipmentMutation,
    variables: { equipmentId },
  })

export const updateEquipmentStatus = ({ status, equipmentId }) =>
  gqlMutate({
    mutation: updateEquipmentStatusMutation,
    variables: { status, equipmentId },
  })

export const resetEquipment = ({ equipmentId }) =>
  gqlMutate({
    mutation: resetEquipmentMutation,
    variables: { equipmentId },
  })

export const resyncEquipments = ({ siteId }) =>
  gqlMutate({
    mutation: resyncEquipmentsMutation,
    variables: {
      siteId,
    },
  })

export const deleteEquipment = ({ equipmentId }) =>
  gqlMutate({
    mutation: deleteEquipmentMutation,
    variables: { equipmentId },
  })

export const updateEquipmentMaintenanceEmail = ({ siteId, maintenanceEmail }) =>
  gqlMutate({
    mutation: updateTanningIntegrationMutation,
    variables: { siteId, input: { maintenanceEmail } },
  })

export const requestMaintenance = ({ siteId, equipmentId, subject, bodyHtml }) =>
  gqlMutate({
    mutation: requestMaintenanceMutation,
    variables: { siteId, equipmentId, subject, bodyHtml },
  })

export const getTanningEligibility = gqlQuery({
  key: 'TANNING_ELIGIBILITY',
  query: tanningEligibilityQuery,
})

export const getEquipmentSessionTypeAvailability = gqlQuery({
  key: 'EQUIPMENT_SESSION_TYPE_AVAILABILITY',
  query: equipmentSessionTypeAvailabilityQuery,
})

export const getMaintenanceEmailConfigured = gqlQuery({
  key: 'MAINTENANCE_EMAIL_CONFIGURED',
  query: maintenanceEmailConfiguredQuery,
})

export const getEquipmentDiagnostics = gqlQuery({
  key: 'EQUIPMENT_DIAGNOSTICS',
  query: equipmentDiagnosticsQuery,
})

export const getTanningAgentDownloadUrl = () =>
  gqlMutate({
    mutation: tanningAgentDownloadUrlMutation,
    variables: {},
  })
